module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.name === 'special') ? _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "section-header with-border"
  }, [_vm._v("\n    专题配置\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "20px",
      "font-size": "14px",
      "color": "red"
    }
  }, [_vm._v("全局配置")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "背景色"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.config.bg.backColor),
      callback: function($$v) {
        _vm.$set(_vm.config.bg, "backColor", $$v)
      },
      expression: "config.bg.backColor"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "背景图片"
    }
  }, [_c('div', {
    staticClass: "setting-item slider"
  }, [(_vm.config.bg.backImg) ? _c('img', {
    staticClass: "banner-uploader",
    attrs: {
      "src": _vm.wximageurl + _vm.config.bg.backImg
    },
    on: {
      "click": function($event) {
        return _vm.handleSpecialBgImgChange(0)
      }
    }
  }) : _c('div', {
    staticClass: "banner-uploader",
    on: {
      "click": function($event) {
        return _vm.handleSpecialBgImgChange(0)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  }), _vm._v("上传图片\n          ")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "角标"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.styleBgIconChange
    },
    model: {
      value: (_vm.config.bg.icon),
      callback: function($$v) {
        _vm.$set(_vm.config.bg, "icon", $$v)
      },
      expression: "config.bg.icon"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("不显示")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("左上角标")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("右上角标")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "左上角标"
    }
  }, [_c('div', {
    staticClass: "setting-item slider"
  }, [(_vm.config.bg.leftIconUrl) ? _c('img', {
    staticClass: "banner-uploader",
    attrs: {
      "src": _vm.wximageurl + _vm.config.bg.leftIconUrl
    },
    on: {
      "click": function($event) {
        return _vm.handleLeftIconUrlImgChange(4)
      }
    }
  }) : _c('div', {
    staticClass: "banner-uploader",
    on: {
      "click": function($event) {
        return _vm.handleLeftIconUrlImgChange(4)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  }), _vm._v("上传图片\n          ")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "右上角标"
    }
  }, [_c('div', {
    staticClass: "setting-item slider"
  }, [(_vm.config.bg.rightIconUrl) ? _c('img', {
    staticClass: "banner-uploader",
    attrs: {
      "src": _vm.wximageurl + _vm.config.bg.rightIconUrl
    },
    on: {
      "click": function($event) {
        return _vm.handlerightIconUrlImgChange(3)
      }
    }
  }) : _c('div', {
    staticClass: "banner-uploader",
    on: {
      "click": function($event) {
        return _vm.handlerightIconUrlImgChange(3)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  }), _vm._v("上传图片\n          ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "font-size": "14px",
      "color": "red"
    }
  }, [_vm._v("秒杀配置")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排列"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.styleFlashSaleChange
    },
    model: {
      value: (_vm.config.flashSale.direction),
      callback: function($$v) {
        _vm.$set(_vm.config.flashSale, "direction", $$v)
      },
      expression: "config.flashSale.direction"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 'row'
    }
  }, [_vm._v("竖排")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'vertical'
    }
  }, [_vm._v("横排")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "横排背景图"
    }
  }, [_c('div', {
    staticClass: "setting-item slider"
  }, [(_vm.config.flashSale.backImg) ? _c('img', {
    staticClass: "banner-uploader",
    attrs: {
      "src": _vm.wximageurl + _vm.config.flashSale.backImg
    },
    on: {
      "click": function($event) {
        return _vm.handleFlashSaleBgImgChange(1)
      }
    }
  }) : _c('div', {
    staticClass: "banner-uploader",
    on: {
      "click": function($event) {
        return _vm.handleFlashSaleBgImgChange(1)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  }), _vm._v("上传图片\n          ")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "横排背景内距"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.config.flashSale.padding),
      callback: function($$v) {
        _vm.$set(_vm.config.flashSale, "padding", $$v)
      },
      expression: "config.flashSale.padding"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "font-size": "14px",
      "color": "red"
    }
  }, [_vm._v("优惠券配置")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "2张排列"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.styleCouponTwoDisplayChange
    },
    model: {
      value: (_vm.config.coupon.directionTwo),
      callback: function($$v) {
        _vm.$set(_vm.config.coupon, "directionTwo", $$v)
      },
      expression: "config.coupon.directionTwo"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("横向")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '2'
    }
  }, [_vm._v("竖向")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "3张排列"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.styleCouponDisplayChange
    },
    model: {
      value: (_vm.config.coupon.directionThree),
      callback: function($$v) {
        _vm.$set(_vm.config.coupon, "directionThree", $$v)
      },
      expression: "config.coupon.directionThree"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": '1'
    }
  }, [_vm._v("一排三列")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '2'
    }
  }, [_vm._v("上一下二")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": '3'
    }
  }, [_vm._v("上二下一")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "4张排列"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.styleCouponFourDisplayChange
    },
    model: {
      value: (_vm.config.coupon.directionFour),
      callback: function($$v) {
        _vm.$set(_vm.config.coupon, "directionFour", $$v)
      },
      expression: "config.coupon.directionFour"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 'tile'
    }
  }, [_vm._v("两排两列")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 'scroll'
    }
  }, [_vm._v("滑动")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "4张滑动背景"
    }
  }, [_c('div', {
    staticClass: "setting-item slider"
  }, [(_vm.config.coupon.backImg) ? _c('img', {
    staticClass: "banner-uploader",
    attrs: {
      "src": _vm.wximageurl + _vm.config.coupon.backImg
    },
    on: {
      "click": function($event) {
        return _vm.handleCouponBgImgChange(2)
      }
    }
  }) : _c('div', {
    staticClass: "banner-uploader",
    on: {
      "click": function($event) {
        return _vm.handleCouponBgImgChange(2)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-camera"
  }), _vm._v("上传图片\n          ")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "4张滑动背景内距"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.config.coupon.padding),
      callback: function($$v) {
        _vm.$set(_vm.config.coupon, "padding", $$v)
      },
      expression: "config.coupon.padding"
    }
  })], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2750bb6c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2750bb6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template_editor/special.vue
// module id = 2553
// module chunks = 0